import React from 'react';
import { type AppRoute } from 'app/store/components/NavigationUtils';

const AppContext = React.createContext<{ routes: AppRoute[] }>({ routes: [] });

export default AppContext;
